import { OVERPASS_URL } from './constants'
import { httpPOST } from './utils'


const Overpass = {
    
    getDataFromOverpass(req_poi_name, body) {
        return new Promise((resolve, reject) => {
            httpPOST(OVERPASS_URL, body)
            .then(data => resolve(data))
            .catch(() => reject("Can't find any " + req_poi_name + " :("));
        });
    },

    getCampsites(search_area, search_radius) {
        let body = "";
        if (search_radius != undefined) { // then a path might have already been computed earlier
            body = "data=[out:json];\
                        (\
                            node\
                                [\"tourism\"=\"camp_site\"]\
                                (around:" + search_radius + "," + search_area + "); \
                            way\
                                [\"tourism\"=\"camp_site\"]\
                                (around:" + search_radius + "," + search_area + "); \
                            rel\
                                [\"tourism\"=\"camp_site\"]\
                                (around:" + search_radius + "," + search_area + "); \
                        );\
                        (._;>;);out meta;"
        } else {
            body = "data=[out:json];\
                        (\
                            node\
                                [\"tourism\"=\"camp_site\"]\
                                (" + search_area[0] + ","+ search_area[1] + ","+ search_area[2] + ","+ search_area[3] + "); \
                            way\
                                [\"tourism\"=\"camp_site\"]\
                                (" + search_area[0] + ","+ search_area[1] + ","+ search_area[2] + ","+ search_area[3] + "); \
                            rel\
                                [\"tourism\"=\"camp_site\"]\
                                (" + search_area[0] + ","+ search_area[1] + ","+ search_area[2] + ","+ search_area[3] + "); \
                        );\
                        (._;>;);out meta;"
        }
        
        return new Promise((resolve, reject) => {
            this.getDataFromOverpass("camp site", body)
            .then(responseText => {
                const res = JSON.parse(responseText);
                let campsites = [];
                for (const el of res.elements) {
                    if(el.type === "node") {
                        if (!el.tags || !el.tags.tourism == "camp_site") continue;  // then it's a node for way keypoints
                        campsites.push({pos: [el.lat, el.lon], name: el.tags.name, tags: el.tags});
                    } else if (el.type === "way" && el.tags) {
                        const first_node_id = el.nodes[0];
                        const node = res.elements.find((e) => {return e.id === first_node_id;});
                        if (node) {
                            campsites.push({pos: [node.lat, node.lon], name: el.tags.name, tags: el.tags});
                        }
                    }
                }
                resolve(campsites);
            })
            .catch(err => reject(err));
        });
    },

    getTrainStations(search_area) {
        const body = "data=[out:json];\
                    (\
                        node\
                            [\"railway\"=\"station\"]\
                            [\"name\"]\
                            (" + search_area.toString() + ");\
                        way\
                            [\"railway\"=\"station\"]\
                            (" + search_area.toString() + ");\
                    );\
                    (._;>;);out center;";
        
        return new Promise((resolve, reject) => {
            this.getDataFromOverpass("train station", body)
            .then((responseText) => {
                const res = JSON.parse(responseText);
                let train_stations = [];
                for (const el of res.elements) {
                    if (!el.tags)
                        continue;
                    else {
                        if (el.type == "node" && el.tags.name && el.tags.uic_ref) {
                            train_stations.push({pos: [el.lat, el.lon], name: el.tags.name, tags: el.tags});
                        }
                        else if (el.type == "way" && el.tags.uic_ref) {
                            train_stations.push({pos: [el.center.lat, el.center.lon], name: el.tags.name, tags: el.tags});
                        }
                    }
                }
                resolve(train_stations);
            })
            .catch((err) => reject(err));
        });
    },

    getCities(centerPoint, search_radius) {
        //search radius in meter
        
        let body = "";
        body = "data=[out:json];\
                    (\
                        node\
                            [\"place\"=\"city\"]\
                            (around:" + search_radius + "," + centerPoint.lat + "," + centerPoint.lng + "); \
                    );\
                    (._;>;);out meta;"
        
        return new Promise((resolve, reject) => {
            this.getDataFromOverpass("cities around", body)
            .then(responseText => {
                const res = JSON.parse(responseText);
                let cities = [];
                for (const el of res.elements) {
                    cities.push({pos: [el.lat, el.lon]});
                }
                resolve(cities);
                // let campsites = [];
        //         for (const el of res.elements) {
        //             if(el.type === "node") {
        //                 if (!el.tags || !el.tags.tourism == "camp_site") continue;  // then it's a node for way keypoints
        //                 campsites.push({pos: [el.lat, el.lon], name: el.tags.name, tags: el.tags});
        //             } else if (el.type === "way" && el.tags) {
        //                 const first_node_id = el.nodes[0];
        //                 const node = res.elements.find((e) => {return e.id === first_node_id;});
        //                 if (node) {
        //                     campsites.push({pos: [node.lat, node.lon], name: el.tags.name, tags: el.tags});
        //                 }
        //             }
        //         }
        //         resolve(campsites);
            })
            .catch(err => reject(err));
        });
    },
};

export const APIPOI = {
    getTrainStations(search_area, search_radius=0) {
        return Overpass.getTrainStations(search_area, search_radius);
    },

    getCampsites(search_area, search_radius) {
        return Overpass.getCampsites(search_area, search_radius);
    },

    getCities(centerPoint, search_radius=200000) {
        return Overpass.getCities(centerPoint, search_radius);
    }
};